<script setup>
const DEFAULT_ICON_URL = '/images/site/default-photo.svg';
const TEAM_ICON_URL = '/images/site/logo-lenta.svg';
const props = defineProps({
  firstTeam: {
    type: Object,
    required: true,
  },
  secondTeam: {
    type: Object,
    required: true,
  },
  showCity: {
    type: Boolean,
    default: true,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
  isHistory: {
    type: Boolean,
    default: false,
  },
  isHomeLogoWithOpponent: {
    type: Boolean,
    default: true,
  },
  name: {
    type: String,
    default: '',
  },
  isSub: {
    type: Boolean,
    default: false,
  }
});
const imgSize = props.isSmall ? 32 : 50;

</script>

<template>
  <div class="i-teams" :class="{'i-teams_history': isHistory}">
    <template v-if="isHomeLogoWithOpponent">
      <div class="i-teams__wrapper">
        <div class="i-teams__item">
          <div class="i-teams__desc">
            <div class="i-teams__name">{{ firstTeam.name }}</div>
            <div v-if="showCity" class="i-teams__city">{{ firstTeam.city }}</div>
          </div>
          <div class="i-teams__image" :class="{ 'i-teams__image_small': isSmall }">
            <img
              :width="imgSize"
              :height="imgSize"
              :src="firstTeam.imageUrl || TEAM_ICON_URL"
              :alt="firstTeam.name + ' - Лого'"
            >
          </div>
        </div>

        <div class="i-teams__info" :class="{'i-teams__info_small': isSmall}">
          <strong class="i-teams__game" :class="{'i-teams__game_color-black': isSub}">- : -</strong>
        </div>

        <div class="i-teams__item">
          <div class="i-teams__desc">
            <div class="i-teams__name">{{ secondTeam.name }}</div>
            <div v-if="showCity" class="i-teams__city">{{ secondTeam.city }}</div>
          </div>
          <div class="i-teams__image" :class="{ 'i-teams__image_small': isSmall }">
            <img
              :width="imgSize"
              :height="imgSize"
              :src="secondTeam.imageUrl || DEFAULT_ICON_URL"
              :alt="secondTeam.name + ' - Лого'"
            >
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="i-teams__wrapper i-teams__wrapper_single">
        <div class="i-teams__item i-teams__item_single">
          <div class="i-teams__desc">
            <div class="i-teams__name">{{ name || firstTeam.name }}</div>
            <div v-if="showCity" class="i-teams__city">{{ firstTeam.city }}</div>
          </div>
          <div class="i-teams__image" :class="{ 'i-teams__image_small': isSmall }">
            <img
              :width="imgSize"
              :height="imgSize"
              :src="firstTeam.imageUrl || TEAM_ICON_URL"
              :alt="firstTeam.name + ' - Лого'"
            >
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<style lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-teams.scss";
</style>
